import { ApiEntity } from "../../Api/api.model";
import { type, string, nullable } from "superstruct";
import { validateStruct } from "../../../utils/validate";
import { MediaAsset, MediaAssetStruct } from "../../../utils/assets";

export interface Tutorial {
  id: string;
  tutorialTitle: string;
  text: string;
  icon: string;
  tutorialId: string;
  img: MediaAsset;
}

const TutorialStruct = type({
  id: string(),
  tutorialTitle: string(),
  text: string(),
  icon: nullable(string()),
  tutorialId: string(),
  img: nullable(MediaAssetStruct),
});

export class TutorialEntity extends ApiEntity<Array<Tutorial>> {
  constructor() {
    super("tutorials");
  }
  validate(rawData: Array<any>): Array<Tutorial> {
    return rawData.map((rawItem) =>
      validateStruct<Tutorial>(rawItem, TutorialStruct, this.endPoint, [
        { field: "id", transform: (id: number) => id.toString() },
      ])
    );
  }
}
